import { MessagingPlatform } from '@this+that/models';
import log from 'loglevel';

import { useFetchCacheStore } from '../../store/FetchCache';

const inFlight = new Map<string, Promise<boolean>>();

interface GuardedFetchParams<T> {
  key: MessagingPlatform;
  scope?: string | null;
  forceRefresh?: boolean;
  fetch: () => Promise<T>;
  write: (data: T) => void;
}

export async function guardedIntegrationFetch<T>({
  key,
  scope = null,
  forceRefresh = false,
  fetch,
  write,
}: GuardedFetchParams<T>): Promise<boolean> {
  const cacheKey = scope ? `${key}:${scope}` : key;
  const { isIntegrationGuardValid, markIntegrationGuard } =
    useFetchCacheStore.getState();

  if (!forceRefresh) {
    const existing = inFlight.get(cacheKey);
    if (existing) {
      return existing;
    }
    if (isIntegrationGuardValid(key, scope)) {
      return true;
    }
  }

  const promise = (async () => {
    try {
      const data = await fetch();
      write(data);
      markIntegrationGuard(key, scope);
      return true;
    } catch (error) {
      log.error(`Error fetching ${key} integration:`, error);
      return false;
    } finally {
      inFlight.delete(cacheKey);
    }
  })();

  inFlight.set(cacheKey, promise);
  return promise;
}
